import { AddCircleOutlineOutlined } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { useSafePush } from '@omnea-app/fe-routing/useSafePush'

export const DashboardEmptyState = () => {
  const { t } = useTranslation('dashboard')
  const { safeUrlPush } = useSafePush()
  const handleCreateNewClick = () => safeUrlPush('/start')

  const view = {
    text: t('request-section.no-requests'),
    imagePath: '/app/assets/dashboard-empty-state.svg',
    imageDimensions: { height: 172, width: 243 },
  }

  return (
    <Stack gap={3} padding={1} sx={{ width: '100%' }}>
      <Stack direction="row" justifyContent="space-between">
        <Typography color="neuralDark.500" variant="display-h3">
          {t('request-section.title.no-requests')}
        </Typography>
      </Stack>
      <Box sx={{ bgcolor: 'bg.surface.default', borderRadius: 2, border: '1px solid', borderColor: 'border.subtle', p: 3 }}>
        <Stack sx={{ justifyContent: 'center', p: 8, flex: 1 }}>
          <Stack gap={6} sx={{ textAlign: 'center' }} justifyContent="center" alignItems="center">
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                pt: 4,
              }}
            >
              <Image
                alt="No requests"
                src={view.imagePath}
                width={view.imageDimensions.width}
                height={view.imageDimensions.height}
              />
            </Box>
            <Typography color="text.muted" variant="body-regular">
              {view.text}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleCreateNewClick()}
              data-testid="btn-workflow-add"
              startIcon={<AddCircleOutlineOutlined />}
              sx={{ width: 162, height: 36 }}
            >
              {t('request-section.new-request')}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  )
}
